import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { toastSuccess, toastError } from "../../../utils";
import AttachmentIcon from "../../../components/VectorIcons/AttachmentIcon";
import ScriptBox from "../../../components/ScriptBox/ScriptBox";
import AppContext from "../../../context/appContext";
import TableListFiles from "../ListFiles/TableListFiles";
import { deleteService } from "../../../services/axios/services";
import UserContext from "../../../context/userContext";
import ConfirmationBox from "../../../components/ConfirmationBox/ConfirmationBox";
import UploadSection from "../../../components/UploadSection/UploadSection";
import UploadService from "../../../components/UploadService/UploadService";
import BoxFooter from "../../../components/BoxFooter/BoxFooter";
import Button from "../../../components/Button/Button";
import SimpleScriptBox from "../SimpleScriptBox/SimpleScriptBox";
import EditIcon from "../../../components/VectorIcons/EditIcon";
import EditFile from "../EditFile/EditFile";
import FileShareBox from "../FileShareBox/FileShareBox";
import ModalActionsFooter from "../../../components/ModalActionsFooter/ModalActionsFooter";
import ReleaseFlowContext from "../../../context/releaseFlowContext";
import {
  uploadContentSheetAttachments,
  editContentAttachment,
} from "../../../services/api/attachments/attachments.api";
import { useAttachmentActions } from "../../../shared/utils/useAttachmentsActions";
import { handleDramaturgyTypeByFormat } from "../../../shared/utils/handleDramaturgyTypeByFormat";

const ContentAttachments = (props) => {
  const {
    data,
    idProject,
    type,
    projectType,
    format,
    havePermission,
    condition,
    isExternal,
    downloadContext,
    sharingPermissions,
    reload,
    refetchAttachments,
  } = props;

  const appContext = useContext(AppContext);
  const userContext = useContext(UserContext);
  const releaseFlowContext = useContext(ReleaseFlowContext);

  const haveSharerPermission = userContext.hasPermission({
    required: ["AttachmentSharingWrite"],
  });

  const hasReleasePermission = userContext.hasPermission({
    required: ["AttachmentRelease"],
  });

  const canManageSelection = haveSharerPermission || hasReleasePermission;

  const [stateConfirmationBox, setStateConfirmationBox] = useState(false);
  const [stateFiles, setStateFiles] = useState([]);
  const [localData, setLocalData] = useState([]);
  const [stateEditFileBox, setStateEditFileBox] = useState({
    open: false,
    currentFile: "",
  });

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [openShareBox, setOpenShareBox] = useState(false);

  const {
    fetchAttachmentActions,
    canDelete,
    getDeleteUnavailableMessage,
    canReleaseChannel,
    canUnReleaseChannel,
    getReleaseUnavailableMessage,
    getUnReleaseUnavailableMessage,
    canDownload,
  } = useAttachmentActions();

  useEffect(() => {
    if (!data?.length) return;

    const ids = data.map((i) => i.id);

    fetchAttachmentActions(ids);
  }, [data, fetchAttachmentActions]);

  const headerList = [
    { label: "Tipo", className: "" },
    { label: "Versao", className: "large" },
    { label: "Artigo", className: "editItem" },
    { label: "RECEBIDO EM", className: "editItem" },
  ];

  const validAttachmentTypes = appContext.currentOriginFileType?.result?.filter(
    (item) => item.name !== "Capítulo/Episódio"
  );

  useEffect(() => {
    setLocalData(data || []);
  }, [data]);

  const handleDeleteFile = (file) => {
    appContext.setShowGlassLoading(true);

    deleteService({
      endpoint: `Attachments/${file.id}`,
      api: "v2",
    })
      .then(() => {
        appContext.setShowGlassLoading(false);

        toastSuccess(`Arquivo ${file.fileName} deletado com sucesso`);

        setStateConfirmationBox((prev) => ({
          ...prev,
          open: false,
        }));

        setLocalData((prev) => prev.filter((item) => item.id !== file.id));

        refetchAttachments();
      })
      .catch(() => {
        appContext.setShowGlassLoading(false);

        toastError(`Erro ao deletar ${file.fileName}`);
      });
  };

  const handleConfirmationDeleteFile = (item) => {
    setStateConfirmationBox({
      ...stateConfirmationBox,
      open: true,
      currentFile: item,
    });
  };

  const closedBox = () => {
    setStateConfirmationBox({
      ...stateConfirmationBox,
      open: false,
    });
  };

  const getDuplicateFiles = (files) => {
    const filesName = files
      .map((e) => `${e[0].originalName} ja foi selecionado!`)
      .join("\n");
    toastError(filesName);
  };

  const getFiles = (files) => {
    setStateFiles({
      ...stateFiles,
      files,
    });
  };

  const uploadFilesIsValid = () => {
    if (!!stateFiles.files && stateFiles.files.length > 0) {
      return (
        stateFiles.files.every((file) => !!file.attachmentTypeId) &&
        stateFiles.files.every((stateFile) => stateFile.isSent === true)
      );
    }
  };

  const handleEditFile = (item) => {
    setStateEditFileBox({
      ...stateEditFileBox,
      open: true,
      currentFile: item,
    });
  };

  const sendFile = () => {
    appContext.setShowGlassLoading(true);

    const obj = stateFiles.files.map((file) => ({
      contentId: idProject,
      fileId: file._meta.tempFileName,
      fileName: file.originalName,
      version: file.version,
      receivedAt:
        appContext.transformDateToUTC(file.receiveAt) || file.receiveAt || null,
      releaseDate: null,
      attachmentTypeId: file.attachmentTypeId,
      blockNumber: file.blockNumber,
      chapterNumber: file.chapterNumber,
      registerType: 2,
      genresIds: [0],
      spacesIds: [0],
      release: 0,
      contentOrigns: [
        {
          contentOriginId: 0,
          contentOriginDescriptions: ["string"],
        },
      ],
      narratives: [0],
    }));

    uploadContentSheetAttachments({ attachments: obj })
      .then(() => {
        appContext.setShowGlassLoading(false);
        toastSuccess("Arquivo cadastrado com sucesso!");
        appContext.setCurrentStepBox("closed");
        reload();
      })
      .catch(() => {
        appContext.setShowGlassLoading(false);
        toastError("Erro ao cadastrar o arquivo!");
        appContext.setCurrentStepBox("closed");
      });
  };

  const sendEditFile = (obj) => {
    appContext.setShowGlassLoading(true);
    editContentAttachment({ attachmentId: obj.id, attachment: obj })
      .then(() => {
        setStateEditFileBox({
          ...stateEditFileBox,
          open: false,
        });
        appContext.setShowGlassLoading(false);
        toastSuccess(
          `Arquivo ${stateEditFileBox.currentFile.fileName} atualizado com sucesso`
        );
        reload();
      })
      .catch(() => {
        toastError(
          `Erro ao tentar atualizar ${stateEditFileBox.currentFile.fileName}!`
        );
        appContext.setShowGlassLoading(false);
      });
  };

  const closedBoxEdit = () => {
    setStateEditFileBox({ ...stateEditFileBox, open: false });
  };

  const handleSelectOrShare = useCallback(() => {
    if (isSelectionMode) {
      if (selectedFiles.length === 0) return;
      setOpenShareBox(true);
    } else {
      setIsSelectionMode(true);
    }
  }, [isSelectionMode, selectedFiles]);

  const handleCancelSelection = useCallback(() => {
    setSelectedFiles([]);
    setIsSelectionMode(false);
  }, []);

  const handleOpenShareBox = useCallback(() => setOpenShareBox(true), []);

  // Adendos have no version number of their own; ReleaseFlowStepVersions
  // needs to know whether to look up chapter or episode associations for
  // them. Tag it once here (where the project's format is already known)
  // instead of threading `format` through the global release flow state.
  const isChapterAddendum = useMemo(
    () => handleDramaturgyTypeByFormat(format) === "Dramaturgia Longa",
    [format]
  );

  const releaseAllData = useMemo(
    () =>
      localData.map((attachment) =>
        attachment.attachmentType?.name === "Adendo"
          ? { ...attachment, isChapterAddendum }
          : attachment
      ),
    [localData, isChapterAddendum]
  );

  const handleOpenRelease = useCallback(
    () =>
      releaseFlowContext.openReleaseFlow({
        attachments: selectedFiles,
        contentId: idProject,
        reload,
        onSuccess: handleCancelSelection,
        allData: releaseAllData,
        type,
        condition,
      }),
    [
      releaseFlowContext,
      selectedFiles,
      idProject,
      reload,
      handleCancelSelection,
      releaseAllData,
      type,
      condition,
    ]
  );

  useEffect(() => {
    if (appContext.current.step === "closed") {
      handleCancelSelection();
    }
  }, [appContext, handleCancelSelection]);

  return (
    <div>
      {appContext.current.step === "editAttachment" && (
        <ScriptBox
          open={appContext.current.step === "editAttachment"}
          icon={<AttachmentIcon color="#FFF" />}
          removePadding={true}
          title="Anexos"
          size="width-1100"
        >
          <TableListFiles
            headerList={headerList}
            handleEditFile={handleEditFile}
            handleConfirmationDeleteFile={handleConfirmationDeleteFile}
            renderCreatedAt={true}
            data={localData}
            type={type === "literaryworks" ? type : "dramaturgy"}
            projectType={projectType}
            condition={condition}
            havePermission={havePermission}
            reload={reload}
            isExternal={isExternal}
            downloadContext={downloadContext}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            isSelectionMode={isSelectionMode}
            sharingPermissions={sharingPermissions}
            canDelete={canDelete}
            canDownload={canDownload}
            getDeleteUnavailableMessage={getDeleteUnavailableMessage}
            canReleaseChannel={canReleaseChannel}
            canUnReleaseChannel={canUnReleaseChannel}
            getReleaseUnavailableMessage={getReleaseUnavailableMessage}
            getUnReleaseUnavailableMessage={getUnReleaseUnavailableMessage}
            contentId={idProject}
          />

          {canManageSelection && (
            <ModalActionsFooter
              isSelectionMode={isSelectionMode}
              selectedCount={selectedFiles.length}
              onCancel={handleCancelSelection}
              onShare={handleOpenShareBox}
              onRelease={handleOpenRelease}
              canShare={haveSharerPermission}
              canRelease={hasReleasePermission}
              selectedFiles={selectedFiles}
              handleSelectOrShare={handleSelectOrShare}
              hasFiles={!!data?.length}
            />
          )}
        </ScriptBox>
      )}

      {appContext.current.step === "uploadAttachment" && (
        <ScriptBox
          open={appContext.current.step === "uploadAttachment"}
          title="Novo Anexo"
          icon={<AttachmentIcon color="#FFF" />}
          marginBottom={true}
        >
          <div className="scriptBoxUpload">
            <UploadSection>
              <UploadService
                thesaurusFileType={validAttachmentTypes}
                handleOnComplete={getFiles}
                getDuplicateFiles={getDuplicateFiles}
              />
            </UploadSection>
          </div>

          <BoxFooter>
            <Button
              text="Salvar"
              toValidate={true}
              isValidForm={uploadFilesIsValid()}
              classButton="buttonGreen large"
              typeButton="submit"
              dataQA="button-prospect-edit"
              clickEvent={sendFile}
            />
          </BoxFooter>
        </ScriptBox>
      )}

      {stateEditFileBox.open && (
        <SimpleScriptBox
          open={stateEditFileBox.open}
          toggleScriptBox={() => closedBoxEdit()}
          title={stateEditFileBox.currentFile.fileName}
          icon={<EditIcon color="#FFF" />}
          removePadding={true}
        >
          <EditFile
            fileName={stateEditFileBox.currentFile.fileName}
            versionNumber={parseInt(1)}
            thesaurusFileType={appContext.currentOriginFileType.result}
            handleChangeDate={() => {}}
            value={1}
            file={stateEditFileBox.currentFile}
            sendFileEdit={sendEditFile}
            condition={condition}
          />
        </SimpleScriptBox>
      )}

      {stateConfirmationBox.open && (
        <ConfirmationBox
          open={stateConfirmationBox.open}
          textButton="Sim, excluir"
          closedBox={closedBox}
          handleEvent={() => handleDeleteFile(stateConfirmationBox.currentFile)}
          title="Tem certeza?"
          text="Este anexo será excluído permanentemente do sistema e essa ação não poderá ser desfeita"
        />
      )}

      {openShareBox && (
        <FileShareBox
          open={openShareBox}
          setOpen={setOpenShareBox}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          onClose={() => {
            setOpenShareBox(false);
          }}
          reload={reload}
          projectId={idProject}
        />
      )}
    </div>
  );
};

export default ContentAttachments;
